/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		// Validar que la URL tenga un product_id válido antes de hacer la petición
		const url = this.dataset.url;
		if (url && url.includes('product_id=&')) {
			// No hacer la petición si product_id está vacío
			return;
		}
		
		fetch(this.dataset.url)
			.then(response => {
				// Silenciar errores 422
				if (response.status === 422) {
					return Promise.reject(new Error('Silenced 422'));
				}
				return response.text();
			})
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

				// Esperar a que todo el contenido (incluyendo swatches) esté renderizado
				this.waitForContentRender().then(() => {
					const event = new CustomEvent('plus-product-recommendations-loaded', {
						bubbles: true,
					});
					this.dispatchEvent(event);
				});

			})
			.catch(e => {
				// Silenciar errores 422 y otros errores esperados
				if (e.message && e.message.includes('Silenced')) {
					return;
				}
				// Solo mostrar errores inesperados
				if (e.message && !e.message.includes('422') && !e.message.includes('404')) {
					console.error(e);
				}
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}

	waitForContentRender() {
		return new Promise((resolve) => {
			// Forzar reflow inicial
			this.offsetHeight;

			const checkContent = setInterval(() => {
				const productCards = this.querySelectorAll('.product-card');
				if (productCards.length === 0) {
					return;
				}

				const allRendered = Array.from(productCards).every(card => {
					const shippingInfo = card.querySelector('.shipping-info');
					const metafieldEnvio = card.querySelector('.metafield-envio.cc');
					const swatches = card.querySelector('.product-card-swatches');
					const swatchesContainer = card.querySelector('.product-card-swatches--container');

					const shippingOk = shippingInfo ? shippingInfo.offsetHeight > 0 : true;
					const metafieldOk = metafieldEnvio ? metafieldEnvio.offsetHeight > 0 : true;

					let swatchesOk = true;
					if (swatches || swatchesContainer) {
						swatchesOk = (swatches && swatches.offsetHeight > 0) ||
							(swatchesContainer && swatchesContainer.offsetHeight > 0) ||
							(swatches && swatches.querySelector('.product-card-swatch')) ||
							(swatchesContainer && swatchesContainer.querySelector('.product-card-swatches'));
					}

					return shippingOk && metafieldOk && swatchesOk;
				});

				if (allRendered) {
					clearInterval(checkContent);
					requestAnimationFrame(() => {
						requestAnimationFrame(resolve);
					});
				}
			}, 100);

			// Timeout de seguridad
			setTimeout(() => {
				clearInterval(checkContent);
				requestAnimationFrame(() => {
					requestAnimationFrame(resolve);
				});
			}, 3000);
		});
	}
}

customElements.define('product-recommendations', ProductRecommendations);
